import { Link } from "react-router-dom";
import { Seo, breadcrumbSchema } from "@/components/Seo";
import { Breadcrumbs } from "@/components/Blocks";
import { SERVICES } from "@/data/services";
import { INDUSTRY_PAGES } from "@/data/industries";

const GROUPS = [
  ["Main pages", [["Home", "/"], ["About Us", "/about"], ["Services", "/services"], ["Industries We Serve", "/industries"], ["Software & Digital Transformation", "/solutions"], ["Portfolio", "/portfolio"], ["Our Process", "/process"], ["Contact Us", "/contact"]]],
  ["Services", SERVICES.map((s) => [s.title, `/services/${s.slug}`])],
  ["Industries", INDUSTRY_PAGES.map((i) => [i.name, `/industries/${i.slug}`])],
  ["Legal", [["Privacy Policy", "/privacy-policy"], ["Terms & Conditions", "/terms-and-conditions"]]],
];

export default function Sitemap() {
  const crumbs = [["Home", "/"], ["Sitemap", "/sitemap"]];
  return (
    <>
      <Seo title="Sitemap | Industrix Solution" description="All pages on the Industrix Solution website: services, industries, solutions, process, about, contact and legal pages." path="/sitemap" jsonLd={[breadcrumbSchema(crumbs)]} />
      <section className="wrap py-12 lg:py-16">
        <Breadcrumbs items={crumbs} />
        <h1 className="text-4xl font-extrabold sm:text-5xl lg:text-6xl" data-testid="page-title">Sitemap</h1>
        <div className="mt-16 grid gap-12 sm:grid-cols-2 lg:grid-cols-4" data-testid="html-sitemap">
          {GROUPS.map(([g, links]) => (
            <div key={g}>
              <h2 className="eyebrow">{g}</h2>
              <ul className="mt-5 space-y-3">
                {links.map(([n, p]) => <li key={p}><Link to={p} className="text-[15px] hover:text-rust-ink hover:underline">{n}</Link></li>)}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
